import React, { useMemo } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import Box from 'carbon-react/lib/components/box';

import { LISTING_PAGE_TABS_HEIGHT } from '@futrli/ui-components/components/listing-page/listing-page-tabs/listing-page-tabs';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { useNavHeight } from '@futrli/predict/hooks/useNavHeight';
import { WorkspaceListView } from '@futrli/views/views/workspaces/WorkspaceListView/WorkspaceListView';

import { OrganisationsActionsProvider } from '../../../context/organisations-actions-context/organisations-actions-context';
import { useWorkspacesFilters } from '../../../hooks/use-workspaces-filters/use-workspaces-filters';
import { WorkspacesOrganisationsList } from '../../../components/workspaces-organisations-list/workspaces-organisations-list';
import { WorkspacesOrganisationsListFilterBar } from '../../../components/workspaces-organisations-list-filter-bar/workspaces-organisations-list-filter-bar';

export const OrganisationsTabContainer = () => {
  const flags = useFlags();
  const { workspaceId = '' } = useParams();

  const view = useApiView(useMemo(() => new WorkspaceListView(flags, workspaceId, true), [flags, workspaceId]));
  const { workspace, isLoading } = view.state;

  const workspaces = useMemo(() => (workspace ? [workspace] : []), [workspace]);

  const {
    searchTerm,
    onSearchChange,
    onWorkspaceFilterChange,
    onDatasourceFilterChange,
    onStatusFilterChange,
    filteredWorkspaces,
    workspaceFilterValue,
    datasourceFilterValue,
    statusFilterValue
  } = useWorkspacesFilters(workspaces, true);

  const { navHeight } = useNavHeight();

  return (
    <OrganisationsActionsProvider>
      <Box mt={1}>
        <WorkspacesOrganisationsListFilterBar
          onSearchChange={onSearchChange}
          onWorkspaceFilterChange={onWorkspaceFilterChange}
          onDatasourceFilterChange={onDatasourceFilterChange}
          onStatusFilterChange={onStatusFilterChange}
          searchTerm={searchTerm}
          stickyTop={navHeight + LISTING_PAGE_TABS_HEIGHT}
          datasourceFilterValue={datasourceFilterValue}
          statusFilterValue={statusFilterValue}
          workspaceFilterValue={workspaceFilterValue}
          workspaces={workspaces}
          hideWorkspaceFilter
        />
        <Box mt={3}>
          <WorkspacesOrganisationsList workspaces={filteredWorkspaces} isLoading={isLoading} hideWorkspaceColumn />
        </Box>
      </Box>
    </OrganisationsActionsProvider>
  );
};
